<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="onKeyDown($event)">
    <div class="row">
        <div class="col-24">
            <h1>My Clients</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Enter Medicare Number (without dashes)'"
                                    [text]="FmoModel.searchText"
                                    (onValueChange)="FmoModel.searchText = $event">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button type="submit" class="button primary" (click)="searchByMedicare()">Search</button>
            <button id="btnBack" class="button cancel" (click)="onBack()">Back</button>
        </div>
    </div>

    <div class="row">
        <div class="col-2">
            <a id="btnPrint" class="link-button link print" (click)="onPrint()" (keydown.enter)="onPrint()" tabindex="0">Print</a>
        </div>
        <div class="col-8">
            <button id="btnExport" class="button link excel" (click)="onExport()">Export to Excel</button>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <!--<div class="bottom-20">-->
            <div class="jqgrid-header-wrap">
                <jqxGrid [width]="1240" [source]="dataAdapter" [columns]="columns"  [autorowheight]="true"
                         [autoshowcolumnsmenubutton]="false"  [autoheight]="true" [pageable]="false" [sortable]="true" 
                         [columnsresize]="true" [selectionmode]="'multiplecellsadvanced'"
                         (onCellclick)="Cellclick($event)"
                         #gridReference></jqxGrid>
            </div>

            <!--<div class="jqgrid-header-wrap">
                <jqxGrid [width]="width"
                         [virtualmode]="true"
                         [source]="dataAdapter"
                         [columns]="columns"
                         [autorowheight]="true"
                         [autoshowcolumnsmenubutton]="false"
                         [autoheight]="true"
                         [pageable]="true"
                         [pagesizeoptions]="[20, 50, 100]"
                         [pagesize]="50"
                         [sortable]="true"
                         [filterable]="true"
                         [columnsresize]="true"
                         [ready]="ready"
                         [selectionmode]="'multiplecellsadvanced'"
                         (onCellclick)="Cellclick($event)"
                         #gridReference>
                </jqxGrid>
            </div>-->
            <!--</div>-->
        </div>
    </div>
</div>